import { useCallback, useEffect, useRef, useState } from 'react';

import type { JScanifyInstance } from 'types/opencv';
import { loadScannerLibraries } from 'utils/opencvLoader';

export const useScannerEngine = () => {
  const scannerRef = useRef<JScanifyInstance | null>(null);
  const [scannerReady, setScannerReady] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('Loading scanner engine...');
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const initialize = async () => {
      try {
        setLoadingMessage('Loading ...');
        await loadScannerLibraries();

        if (!mounted) {
          return;
        }

        scannerRef.current = new window.jscanify!();
        setScannerReady(true);
        setLoadingMessage('');
        setLoadError(null);
      } catch (error) {
        console.error('Scanner engine load failed:', error);
        if (mounted) {
          setLoadError('Failed to load document scanner. Please refresh and try again.');
          setLoadingMessage('');
        }
      }
    };

    initialize();

    return () => {
      mounted = false;
    };
  }, []);

  const getScanner = useCallback(() => scannerRef.current, []);

  return {
    scannerReady,
    loadingMessage,
    loadError,
    getScanner,
  };
};
